import { ApolloClient, InMemoryCache } from 'apollo-boost';
import { setContext } from 'apollo-link-context';
import { createHttpLink } from 'apollo-link-http';

export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL || '';

const httpLink = createHttpLink({
  uri: `${BASE_API_URL}/admin/api`, // Server URL (must be absolute)
  credentials: 'same-origin',
});

const authLink = setContext((_, { headers }) => {
  const apiKey = localStorage.getItem('api-key');

  if (apiKey != null && typeof apiKey !== 'undefined') {
    return {
      headers: {
        ...headers,
        Authorization: `Bearer ${apiKey}`,
      },
    };
  }
  return { headers };
});

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
